<template>
    <div class="container">
        <div class="box">
            <h3 class="title reveal-bottom">{{ $t("csa.t1") }}</h3>
            <p class="text reveal-bottom">
                {{ $t("csa.c1") }}
            </p>
            <div class="img1 reveal-bottom">
                <img class="img" :src="imgUrl" alt="img" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "content1",
    data() {
        return {
            imgUrl: require("@/assets/images/cloud_saaS_acceleration_img_2.jpg"),
        };
    },
};
</script>
<style scoped>
.container {
    overflow: hidden;
    background-color: #fff;
}
.box {
    width: 1200px;
    margin: auto;
    padding: 0 10px;
    box-sizing: border-box;
}
.title {
    font-size: 44px;
    color: #000000;
    letter-spacing: 0;
    line-height: 66px;
    margin-top: 150px;
}
.text {
    font-size: 22px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 44px;
    margin-top: 41px;
}
.img {
    width: 1180px;
    height: 488px;
    margin-bottom: 212px;
}
.img1 {
    width: 1180px;
    height: 488px;
    margin-top: 133px;
    margin-bottom: 212px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/CloudSaasAccerlation/Content1.vue